import type { PropsWithChildren } from "react";
import type { VariantProps } from "tailwind-variants";
import { tv } from "tailwind-variants";

const chipVariants = tv({
  base: "rounded-full px-3 py-1 text-sm border inline-flex items-center min-w-20 justify-center",
  variants: {
    type: {
      success: "bg-green-50 text-black border-green-300",
      neutral: "bg-gray-100 text-gray-700 border-gray-400",
      lavender:
        "bg-placebo-lavender text-indigo-charcoal text-base border-violet80 border-1",
      violet: "bg-white text-violet border-violet",
      blue: "bg-white text-blue border-blue",
    },
    size: {
      md: "",
      sm: "min-w-0 px-2 py-0.5 text-xs",
    },
  },
  defaultVariants: { type: "neutral", size: "md" },
});

export type ChipProps = VariantProps<typeof chipVariants> & {
  className?: string;
};

export const Chip = ({
  type,
  size,
  className,
  ...props
}: PropsWithChildren<ChipProps>) => (
  <span className={chipVariants({ type, size, className })} {...props} />
);
